'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseIcons = require('@bibliocommons/base-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var statusMap = {
  IN_LIBRARY_USE: _baseIcons.Checkmark,
  AVAILABLE: _baseIcons.Checkmark,
  UNAVAILABLE: _baseIcons.MinusCircled,
  ON_ORDER: _baseIcons.Clock,
  UNKNOWN: _baseIcons.RightArrowCircled,
  _default: _baseIcons.RightArrowCircled
};

var colorMap = {
  UNAVAILABLE: '#cc441e',
  AVAILABLE: '#008000',
  ON_ORDER: '#e65722',
  _default: '#666'
};

var AvailabilityIcon = function AvailabilityIcon(_ref) {
  var _ref$status = _ref.status,
      status = _ref$status === undefined ? 'UNKNOWN' : _ref$status,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['status', 'className']);

  var colorVariant = colorMap[status] || colorMap._default;
  var StatusIcon = statusMap[status] || statusMap._default;
  var classString = (0, _classnames2.default)('cp-availability-icon', status.toLowerCase(), className);

  return _react2.default.createElement(StatusIcon, _extends({}, props, { color: colorVariant, className: classString }));
};

AvailabilityIcon.propTypes = {
  status: _react.PropTypes.string.isRequired,
  className: _react.PropTypes.string
};

exports.default = AvailabilityIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-picker-token/lib/components/AvailabilityIcon.js
// module id = 834
// module chunks = 9 10